import Bluebird from 'bluebird';
import ajax from './ajax';
import { getApiUrl, getSessionID } from './app-storage';
import { backwardsConvert } from './promises';

function executeCall<T extends API.Response | string>
    (apiVersion: 1 | 2, method: string, path: string, data?: object | null,
    options: { groupURL?: string, ignoreClientErrors?: boolean } = {}): Bluebird<T> {

    // TODO: Automatically select groupURL from predefined list
    const { groupURL, ignoreClientErrors } = options;

    const headers: {
        'Booking-Session'?: string,
        'Content-Type': string,
        'Accept': string,
    } = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    };

    const sessionID = getSessionID();
    if (sessionID) headers['Booking-Session'] = sessionID;

    return ajax<T>(method, `https://${getApiUrl()}/api/v${apiVersion}/${path}`, data,
        { headers, logURL: path, groupURL, ignoreClientErrors })
        .then(response => {
            if (typeof response !== 'string' &&
                typeof (response as API.Response).data === 'undefined') {
                throw new TypeError(`${method} ${path} response contained no data!`);
            }
            return response;
        });
}

export function apiCall<T extends API.Response | string>
    (method: string, path: string, data?: object | null,
    options: { groupURL?: string, ignoreClientErrors?: boolean } = {}): Bluebird<T> {
    return executeCall(1, method, path, data, options);
}

export function api2Call<T extends API.Response | string>
    (method: string, path: string, data?: object | null,
    options: { groupURL?: string, ignoreClientErrors?: boolean } = {}): Bluebird<T> {
    return executeCall(2, method, path, data, options);
}

// TODO: Remove this old jQuery function
export default function apiCallOld<T extends API.Response | string>
    (method: string, path: string, data?: object | null,
    options: { groupURL?: string, ignoreClientErrors?: boolean } = {}): JQueryPromise<T> {
    return backwardsConvert(apiCall(method, path, data, options));
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/services/api.ts